/// <reference path="../../../../../node_modules/@types/daterangepicker/index.d.ts" />
declare var moment;
import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 're-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DateRangeComponent),
        }],
    standalone: false
})
export class DateRangeComponent implements OnInit, ControlValueAccessor {

    private propagateChange = (_: any) => { };
    private propagateTouch = () => { };
    picker: JQuery<HTMLElement>;


    writeValue(obj: DateRange): void {
        if (!obj) {
            this.picker.val("");
            return;
        }
        this.picker.data("daterangepicker").setStartDate(new moment(obj.start));
        this.picker.data("daterangepicker").setEndDate(new moment(obj.end));
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    disabled=false;

    constructor() { }

    @Output()
    dateChanged = new EventEmitter<any>();

    ngOnInit() {


        this.picker = $(this.container.nativeElement).daterangepicker({
            autoApply: false,
            startDate:new moment(),
            endDate:new moment(),
            ranges: {
                Today: [moment(), moment()],
                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Last Week": [moment().subtract(1, "weeks"), moment()],
                "Next Week": [moment(), moment().add(1, "weeks")],
                "Last Month": [moment().subtract(1, "months"), moment()],
                "Next Month": [moment(), moment().add(1, "months")],
                "Last Quarter": [moment().subtract(3, "months"), moment()],
                "Last Year": [moment().subtract(1, "years"), moment()]
            },
            showCustomRangeLabel: false,
            alwaysShowCalendars: true,
        }, (s, e, l) => {
            var data: DateRange = { start: new Date(s.toDate()), end: new Date(e.toDate()) };
            this.propagateChange(data);
            this.dateChanged.emit(data);
        }).blur(() => {
            this.propagateTouch();
        });

        //$(this.container.nativeElement).on('apply.daterangepicker', (ev, picker) => {
        //    var data :DateRange = { start: new Date(picker.startDate), end: new Date(picker.endDate) };
        //    this.propagateChange(data);
        //    this.dateChanged.emit(data);
        //});
        $(this.container.nativeElement).parent().find(".form-control-feedback").on('click',  ()=> {
            $(this.container.nativeElement).trigger('focus');
        })
    }



    @ViewChild("container", { static: true })
    private container: ElementRef;

}

export class DateRange {
    constructor(public start: Date, public end: Date) {

    }
}
